module.exports = __webpack_public_path__ + "media/images/icons/flag-jp-ba90e2c49bd72227aa694b06d1e22908.svg";